define('modules/auth/forms/auth.controller',["client"],
    function(Prospector)
    {
        Prospector.module("AuthApp.Forms", function(Forms, Prospector, Backbone, Marionette, $, _){
            Forms.Controller = {
                loadLogin: function(options){
                    var loginView = null;
                    require(["modules/auth/forms/views/login.view"],
                    function(LoginView){
                        document.title = 'RelPro: Login';
                        loginView = new LoginView();
                        try {
                            Prospector.mainRegion.show(loginView);
                        } catch (e){
                            window.location.reload();
                        }
                    });
                }
            }
        });
        return Prospector.AuthApp.Forms.Controller;
    });

